/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('offersList', {
    templateUrl: 'app/components/offers/list/List.html',
    controller: OffersList,
    bindings: {
      offers: '<',
      personsCount: '<',
      onSave: '&'
    }
  });

function OffersList() {}

OffersList.prototype = {
  handleSave: function (room, rateplan) {
    this.onSave({room: room, rateplan: rateplan});
  }
};
